<template>
  <div class="product-specification">
    <table>
      <tbody>
        <template v-for="filter in filters">
          <tr v-if="selectedFilter(filter)" :key="filter.id">
            <td class="filter-name">
              <h3>{{ filter.name }}</h3>
            </td>
            <td>
              <div class="filter-value text-bold">
                <img v-if="selectedFilter(filter).image" :src="selectedFilter(filter).image" :alt="selectedFilter(filter).name || ''">
                {{ selectedFilter(filter).name }}
              </div>

              <span v-if="findSpecification(filter)" class="output" v-html="generate(findSpecification(filter).value)" />
            </td>
          </tr>
        </template>
        <tr v-if="product && product.ean">
          <td class="filter-name">
            <h3>{{ $t('fields.ean') }}</h3>
          </td>
          <td class="filter-value text-bold">
            {{ product.ean }}
          </td>
        </tr>
        <tr v-if="product && product.brand">
          <td class="filter-name">
            <h3>{{ $t('fields.brand') }}</h3>
          </td>
          <td class="filter-value text-bold">
            {{ product.brand }}
          </td>
        </tr>
        <tr v-if="product && prices">
          <td class="filter-name">
            <h3>{{ $t('fields.price') }}</h3>
          </td>
          <td class="filter-value text-bold">
            {{ toCurrency(prices.price, null, prices.currency) }}
            &nbsp;
            <span v-if="product.typePrices" class="price-info">
              {{ product.typePrices === 'brutto' ? $t('fields.withVat') : $t('fields.withoutVat') }}
            </span>
          </td>
        </tr>
        <template v-if="product">
          <template v-for="specification in product.extendedSpecification">
            <tr v-if="checkFilter(specification)" :key="specification.id">
              <td class="filter-name">
                <h3>{{ specification.name }}</h3>
              </td>
              <td class="specification-value">
                <span v-if="specification.value" class="output" v-html="generate(specification.value)" />
                <div v-if="specification.link && specification.link.length" class="buttons">
                  <b-button
                    v-for="(link, index) in specification.link"
                    :key="index"
                    tag="a"
                    :icon-left="link.icon"
                    class="is-primary"
                    :href="link.url"
                  >
                    {{ link.name }}
                  </b-button>
                </div>
              </td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import bbcodeHTML from 'marketplace-front-core/config/bbcodeHTML'

export default {
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    product: {
      type: Object,
      default: null
    },
    prices: {
      type: Object,
      default: null
    }
  },
  methods: {
    selectedFilter (filter) {
      const selected = filter.options.find(option => option.selected)
      if (selected) {
        const name = selected.name
        let image = null
        if (selected.filePivots.length && selected.filePivots[0].file.sizes) {
          image = selected.filePivots[0].file.sizes.small
        }
        const result = {
          name,
          image
        }
        return result
      } else {
        return null
      }
    },
    generate (content) {
      return bbcodeHTML(content, 'minimal')
    },
    checkFilter (specification) {
      return !this.filters.find((x) => {
        const filterName = x.name
          .replace(/\s/g, '')
          .toUpperCase()

        const specificationName = specification.name
          .replace(/\s/g, '')
          .toUpperCase()

        return filterName === specificationName
      })
    },
    findSpecification (filter) {
      return this.product.extendedSpecification.find((x) => {
        const filterName = filter.name
          .replace(/\s/g, '')
          .toUpperCase()

        const specificationName = x.name
          .replace(/\s/g, '')
          .toUpperCase()

        return filterName === specificationName
      })
    }
  }
}
</script>
